<template>
  <div class="upload">
    <a-upload
      name="file"
      list-type="picture-card"
      class="avatar-uploader"
      action="api/file/upload"
      :show-upload-list = "false"
      :before-upload="beforeUpload"
      :disabled="disabled"
      @change="handleChange"
    >
      <img v-if="imageUrl" :src="imageUrl" width="126" height="126" alt="file" />
      <div v-else>
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">上传</div>
      </div>
    </a-upload>
  </div>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      loading: false,
    };
  },
  props:{
    id:{
      type:Number
    },
    imageUrl:{
      type:String
    },
    disabled:{
      type:Boolean
    }
  },
  methods: {
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, (imageUrl) => {
          // this.imageUrl = imageUrl;
          this.$emit('changeImg',imageUrl,this.id)
          this.loading = false;
        });
      }
      this.$emit('getFile',info,this.id)
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
      if (!isJpgOrPng) {
        this.$message.error('请上传图片格式')
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
         this.$message.error('图片大小需小于 2MB!')
      }
      return isJpgOrPng && isLt2M;
    },
  },
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
